import styled, { css } from 'styled-components';


export const CaptureToolMenuContainer = styled.div`
  max-height: 100vh;
  overflow: auto;
`;

export const CaptureToolSectionContainer = styled.div`
  & ~ & {
    margin-top: 20px;
  };

  input {
    max-width: 100px;
    margin-left: 3px;
  };
`;

export const CaptureToolMenuFunctionButtonContainer = styled(CaptureToolSectionContainer)`
  .ant-btn {
    max-width: 200px;
  }
`;

export const CameraContainer = styled.div<{isSelected:boolean}>`
  display: flex;
  justify-content: space-between;
  width: 310px;
  border: 2px solid black;
  
  & ~ & {
    margin-top: 5px;
  }

  ${(props) => props.isSelected && css`
		border-color: red;
	`}
`;

export const CameraContainerColumn = styled.div`
  &:last-child {
    margin-left: 5px;
  }
`;